import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * One-click add for the cart-drawer upsell. Mirrors Horizon's product-form flow: it dispatches
 * CartLinesUpdateEvent with a promise that resolves with the fresh cart and the re-rendered cart sections,
 * so the drawer, the cart icon and the free-shipping bar update themselves.
 */
class SkUpsellAdd extends HTMLElement {
  connectedCallback() {
    this.querySelector('button')?.addEventListener('click', this.#add);
  }

  disconnectedCallback() {
    this.querySelector('button')?.removeEventListener('click', this.#add);
  }

  #add = async () => {
    const button = this.querySelector('button');
    const variantId = Number(this.dataset.variantId);
    if (!button || !Number.isFinite(variantId)) return;

    button.disabled = true;
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((element) => (element instanceof HTMLElement ? element.dataset.sectionId : undefined))
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();

    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds.join(',') }),
      }).then((res) => res.json());

      if (response.status) throw new Error(response.description || response.message || 'Add to cart failed');

      const cart = await fetch(`${Theme.routes.cart_url}.js`).then((res) => res.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'sk-upsell-add',
          sourceId: String(variantId),
          itemCount: 1,
          sections: response.sections,
          didError: false,
        },
      });
    } catch (error) {
      deferred.reject(error);
      button.disabled = false;
    }
  };
}

if (!customElements.get('sk-upsell-add')) {
  customElements.define('sk-upsell-add', SkUpsellAdd);
}
